import { createStore } from '@shared/utils/state/state-factory'
import { omit } from 'lodash'
import { PubnubStatus } from 'v2/types/pubnub'

interface TabState {
  pubnubStatus: PubnubStatus
  isHydrated: boolean
  isPhoneConnected: boolean // this is a tab specific state to track if the phone is connected
  // Tab-local on purpose: in the shared app store, every open tab's panel sent the queued prompt.
  pendingAssistantPrompt: string | null
  pendingAssistantPromptSource: string | null
}

interface Actions {
  setPubnubStatus: (status: PubnubStatus) => void
  setIsHydrated: (isHydrated: boolean) => void
  setIsPhoneConnected: (isPhoneConnected: boolean) => void
  setPendingAssistantPrompt: (prompt: string | null, source?: string | null) => void
  reset: () => void
}

// State that is shared within the tab
const initialState: TabState = {
  pubnubStatus: PubnubStatus.IDLE,
  isHydrated: false,
  isPhoneConnected: false,
  pendingAssistantPrompt: null,
  pendingAssistantPromptSource: null,
}

export const useTabStore = createStore<TabState & Actions>(
  'tab',
  (set) => ({
    ...initialState,
    reset: () => set(omit(initialState, 'isHydrated', 'userAuthenticated')),
    setPubnubStatus: (status) => set({ pubnubStatus: status }),
    setIsHydrated: (isHydrated) => set({ isHydrated }),
    setIsPhoneConnected: (isPhoneConnected) => set({ isPhoneConnected }),
    setPendingAssistantPrompt: (prompt, source = null) =>
      set({ pendingAssistantPrompt: prompt, pendingAssistantPromptSource: source }),
  }),
  {
    shared: false,
    persist: false,
    onHydrate: () => () => {
      useTabStore.setState({ isHydrated: true })
    },
  },
)
